import { apiConstants } from '../../apiConstant'
import { formDataCommonFunction, formDataCommonFunctionUnAuth, serviceCall } from '../../serviceCall'

const sendOverallFeedback = (data, callback, errorCallBack,params) => {
  
  return async (dispatch) => {
 
    formDataCommonFunctionUnAuth(data,apiConstants.USER.SEND_FEEDBACK)
      .then((response) => {
        callback && callback(response)
      })
      .catch((error) => {
        errorCallBack && errorCallBack(error.response)
      })
  }
}

export default sendOverallFeedback;
